import axios from "axios";
import { API_SERVER, API_PORT } from "../store";

const API_URL =
  (API_PORT === 443 ? "https://" : "http://") +
  API_SERVER +
  ":" +
  API_PORT +
  "/api/maestros/";

const logid = async (id) => {
  try {
    const res = await axios.post(API_URL + "authenticacion/signid", { id });
    if (res.status === 200) {
      //const token = JSON.stringify(res.data.token);
      //localStorage.setItem("user_gandara", token);
    }
    return res;
  } catch (error) {
    //alert(error);
    return error.response;
  }
};

const login = async (user_rut, password) => {
  try {
    // console.log(API_URL + "authenticacion/signin");
    const res = await axios.post(API_URL + "authenticacion/signin", {
      user_rut,
      password,
    });
    if (res.status === 200) {
      const token = JSON.stringify(res.data.token);
      localStorage.setItem("user_gandara", token);
    }
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

const verificar = async () => {
  try {
    const authToken = JSON.parse(localStorage.getItem("user_gandara"));
    const headers = {
      Authorization: `${authToken}`,
    };
    const res = await axios.post(API_URL + "authenticacion/verificar", null, {
      headers,
    });
    return res;
  } catch (error) {
    return error.response;
  }
};

const logout = () => {
  localStorage.removeItem("user_gandara");
};

const Bodegas = async (id, Estado) => {
  try {
    // Parámetros de la solicitud GET
    const params = {
      idsuc: id,
      sEstado: Estado,
    };
    //Authorization: `Bearer ${authToken}`,
    const authToken = JSON.parse(localStorage.getItem("user_gandara"));
    const headers = {
      Authorization: `${authToken}`,
    };
    const res = await axios.get(API_URL + "bodegas", { params, headers });

    return res;
  } catch (error) {
    return error.response;
  }
};

const Sucursales = async (id, Estado) => {
  try {
    // Parámetros de la solicitud GET
    const params = {
      idsuc: id,
      sEstado: Estado,
    };
    //Authorization: `Bearer ${authToken}`,
    const authToken = JSON.parse(localStorage.getItem("user_gandara"));
    const headers = {
      Authorization: `${authToken}`,
    };

    const res = await axios.get(API_URL + "sucursales", { params, headers });

    return res;
  } catch (error) {
    return error.response;
  }
};

const Productolist = async (idSuc, idBod, Codigo, CodigoBarra) => {
  try {
    // Parámetros de la solicitud GET
    const params = {
      idSucursal: idSuc,
      idBodega: idBod,
      sCodigo: Codigo,
      sCodigoBarra: CodigoBarra,
    };
    //Authorization: `Bearer ${authToken}`,
    const authToken = JSON.parse(localStorage.getItem("user_gandara"));
    const headers = {
      Authorization: `${authToken}`,
    };
    const res = await axios.get(API_URL + "productolist", { params, headers });
    return res;
  } catch (error) {
    return error.response;
  }
};

const Get_Documentos = async (sTipo, idSuc, idBod, Numero, Clase) => {
  try {
    // Parámetros de la solicitud GET
    const params = {
      tipoDoc: sTipo,
      NumDoc: Numero,
      idSucursal: idSuc,
      idBodega: idBod,
      clase: Clase,
    };
    console.log(params);
    const authToken = JSON.parse(localStorage.getItem("user_gandara"));
    const headers = {
      Authorization: `${authToken}`,
    };
    const res = await axios.get(API_URL + "documentos", { params, headers });

    return res;
  } catch (error) {
    return error.response;
  }
};

const Producto = async (idSuc, idBod, Codigo, CodigoBarra) => {
  try {
    // Parámetros de la solicitud GET
    const params = {
      idSucursal: idSuc,
      idBodega: idBod,
      sCodigo: Codigo,
      sCodigoBarra: CodigoBarra,
    };
    //Authorization: `Bearer ${authToken}`,
    const authToken = JSON.parse(localStorage.getItem("user_gandara"));
    const headers = {
      Authorization: `${authToken}`,
    };
    const res = await axios.get(API_URL + "producto", { params, headers });
    return res;
  } catch (error) {
    return error.response;
  }
};

const Kardex = async (
  idSuc,
  idBod,
  Codigo,
  FechaDesde,
  FechaHasta,
  TipoUsuario,
  TipoFecha,
) => {
  try {
    // Parámetros de la solicitud GET
    // var _idBod = "B0" + req.idBodega;
    // var _Codigo = req.sCodigo;
    // var _FechaDesde =
    //   req.sFechaDesde; /** 01011800 cuando es todas las fechas  */
    // var _FechaHasta =
    //   req.sFechaHasta; /** 01011800 cuando es todas las fechas  */
    // var _TipoUsuario = req.TipoUsuario;
    // var _TipoFecha = req.TipoFecha; //**** Tipo I = Fecha Ingreso - D = Fecha del Documento * /
    // let sSql = `Call up_obt_kardex('${_idBod}','${_Codigo}','${_Codigo}','',${_TipoUsuario},'${_FechaDesde}','${_FechaHasta}','${_TipoFecha}');`;
    const params = {
      idSucursal: idSuc,
      idBodega: idBod,
      sCodigo: Codigo,
      sFechaDesde: FechaDesde,
      sFechaHasta: FechaHasta,
      sTipoUsuario: TipoUsuario,
      sTipoFecha: TipoFecha,
    };
    //Authorization: `Bearer ${authToken}`,
    const authToken = JSON.parse(localStorage.getItem("user_gandara"));
    const headers = {
      Authorization: `${authToken}`,
    };
    const res = await axios.get(API_URL + "kardex", { params, headers });
    return res;
  } catch (error) {
    return error.response;
  }
};

const enviocorreo = async (Para, Asunto, Mensaje, Adjuntos) => {
  try {
    // const params = {
    //   to: Para,
    //   subject: Asunto,
    //   text: Mensaje,
    //   attachments: Adjuntos,
    // };
    const formData = new FormData();
    formData.append("to", Para);
    formData.append("subject", Asunto);
    formData.append("text", Mensaje);
    Adjuntos.forEach((adjunto, index) => {
      formData.append(`files[${index}]`, adjunto.data);
    });

    const authToken = JSON.parse(localStorage.getItem("user_gandara"));

    const headers = {
      Authorization: `${authToken}`,
    };
    // console.log(API_URL + "enviocorreo", formData);

    return await axios.post(API_URL + "enviocorreo", formData, { headers });
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

const enviocorreodespacho = async (
  TipoEnvio,
  IdUserEnvia,
  IdSucDestino,
  sNomSucOrigen,
  sNomSucDestino,
  sMsjObs,
  Doc,
  Adjuntos,
) => {
  try {
    const formData = new FormData();
    formData.append("TipoEnvio", TipoEnvio);
    formData.append("IdUserEnvia", IdUserEnvia);
    formData.append("IdSucDestino", IdSucDestino);
    formData.append("sNomSucOrigen", sNomSucOrigen);
    formData.append("sNomSucDestino", sNomSucDestino);
    formData.append("sMsjObs", sMsjObs);
    formData.append("Documentos", JSON.stringify(Doc));

    Adjuntos.forEach((adjunto, index) => {
      formData.append(`files[${index}]`, adjunto.data);
    });

    const authToken = JSON.parse(localStorage.getItem("user_gandara"));

    const headers = {
      Authorization: `${authToken}`,
    };
    // console.log(API_URL + "maildespacho", formData);

    return await axios.post(API_URL + "maildespacho", formData, { headers });
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

const bdService = {
  logid,
  login,
  logout,
  verificar,
  Sucursales,
  Bodegas,
  Productolist,
  Producto,
  Kardex,
  enviocorreo,
  enviocorreodespacho,
  Get_Documentos,
};

export default bdService;
